<template>
  <router-link :to="to">
    <div class="rounded-full border p-2 text-green-500">
      <slot></slot>
    </div>
  </router-link>
</template>

<script>
export default {
  name: "SurveyWizardStep",
  props: ['to']
}
</script>

<style scoped>
.router-link-active div {
  @apply border-green-500 text-green-500
}
</style>